import { required, helpers } from 'vuelidate/lib/validators'
const phoneformat = helpers.regex('phoneformat', /^([+])?(([-() ])*(\d+)*)*$/)

export default [{
  "id": "first-name",
  "type": "input",
  "label": "Nombre",
  "size": 50,
  "model": "firstName",
  "validation": {
    required
  },
  "errorMsg": [
    "Indique su nombre."
  ]
},
{
  "id": "last-name",
  "type": "input",
  "label": "Apellidos",
  "size": 50,
  "model": "lastName",
  "validation": {
    required
  },
  "errorMsg": [
    "Indique su apellido."
  ]
},
{
  "id": "mobile1",
  "type": "input",
  "label": "Teléfono Móvil",
  "size": 50,
  "model": "mobile1",
  "validation": {
    required,
    phoneformat
  },
  "errorMsg": [
    "Indique un número de teléfono válido. ",
    "Indique un número de teléfono válido. "
  ]
},
{
  "id": "mobile2",
  "type": "input",
  "label": "Número de teléfono secundario",
  "size": 50,
  "model": "mobile2",
  "validation": {
    phoneformat
  },
  "errorMsg": [
    "Indique un número de teléfono válido. "
  ]
},
{
  "id": "address1",
  "type": "input",
  "label": "Dirección de envío de Línea 1",
  "size": 100,
  "model": "address1",
  "validation": {
    required
  },
  "errorMsg": [
    "Indique su dirección."
  ]
},
{
  "id": "address2",
  "type": "input",
  "label": "Dirección de envío de Línea 2",
  "size": 100,
  "model": "address2"
},
{
  "id": "city",
  "type": "input",
  "label": "CIUDAD",
  "size": 50,
  "model": "city"
},
{
  "id": "state",
  "type": "input",
  "label": "Estado / Provincia",
  "size": 50,
  "model": "state"
},
{
  "id": "postal-code",
  "type": "input",
  "label": "Código postal ",
  "size": 50,
  "model": "postalCode",
  "validation": {
    required
  },
  "errorMsg": [
    "Indique un código postal válido."
  ]
},
{
  "id": "country",
  "type": "text",
  "label": "País / Región",
  "size": 50,
  "model": "countryName"
}
]